import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth/auth.service';

/**
 * PARÁMETROS DE LIQUIDACIÓN EN UNA SOLA OPCIÓN (Mario, 12-oct: «tenemos las cosas muy dispersas»; PAR-01 a 03).
 * En el tablero de Parámetros hay una tarjeta «Liquidación a comercios»; adentro, las opciones agrupadas, y cada una se
 * administra en su pantalla de siempre (con su permiso).
 */
export interface OpcionLiquidacion {
  title: string;
  description: string;
  icon: string;
  route: string;
  requiredRoles: string[];
  rbacPermissions: string[];
  color: string;
}

export const GRUPOS_LIQUIDACION: { titulo: string; descripcion: string; opciones: OpcionLiquidacion[] }[] = [
  {
    titulo: 'Condiciones del comercio',
    descripcion: 'De dónde salen la comisión, el plazo y la fecha de pago de cada venta.',
    opciones: [
      {
        title: 'Tarifario de liquidación',
        description: 'La tabla de plazos y comisiones que se elige al cargar las condiciones de un comercio',
        icon: 'fas fa-table', route: '/console/parametros-sistema/tarifario',
        requiredRoles: ['OWNER'], rbacPermissions: ['config.comercios.terms.read'], color: 'bg-blue-100 text-blue-600',
      },
      {
        title: 'Feriados bancarios',
        description: 'Los días en que no se paga: la fecha de pago pasa al hábil siguiente cuando el contrato lo dice',
        icon: 'fas fa-calendar-times', route: '/console/parametros-sistema/feriados',
        requiredRoles: ['OWNER'], rbacPermissions: ['config.feriados.read'], color: 'bg-blue-100 text-blue-600',
      },
    ],
  },
  {
    titulo: 'Aprobación',
    descripcion: 'Quién firma cada tanda antes de pagar.',
    opciones: [
      {
        title: 'Bandas de aprobación',
        description: 'Quién aprueba cada tanda de liquidación según su monto, con una o dos firmas; versionadas',
        icon: 'fas fa-layer-group', route: '/console/parametros-sistema/bandas',
        requiredRoles: ['OWNER'], rbacPermissions: ['config.bandas.read'], color: 'bg-blue-100 text-blue-600',
      },
    ],
  },
  {
    titulo: 'Pago a los comercios',
    descripcion: 'Desde qué cuentas se paga y con qué formato de archivo de cada banco.',
    opciones: [
      {
        title: 'Cuentas de origen',
        description: 'De dónde sale el pago a los comercios: las cuentas de la empresa pagadora que el tesorero elige al armar cada lote',
        icon: 'fas fa-university', route: '/console/parametros-sistema/cuentas-origen',
        requiredRoles: ['OWNER'], rbacPermissions: ['config.cuentas_origen.update'], color: 'bg-blue-100 text-blue-600',
      },
      {
        title: 'Atención a comercios',
        description: 'El contacto que ve el comercio en su portal cuando no tiene ejecutivo asignado: nombre, teléfono, WhatsApp, correo y horario',
        icon: 'fas fa-headset', route: '/console/parametros-sistema/atencion-comercios',
        requiredRoles: ['OWNER'], rbacPermissions: ['config.comercios.update'], color: 'bg-blue-100 text-blue-600',
      },
      {
        title: 'Integraciones bancarias',
        description: 'El formato del archivo de cada banco (envío y respuesta), con versiones y prueba; se encienden y se apagan',
        icon: 'fas fa-plug', route: '/console/parametros-sistema/integraciones',
        requiredRoles: ['OWNER'], rbacPermissions: ['liquidacion.consultar'], color: 'bg-blue-100 text-blue-600',
      },
    ],
  },
];

/** PAR-01: la tarjeta del tablero la ve quien tiene el permiso de al menos una opción de adentro. */
export const PERMISOS_LIQUIDACION: string[] = [...new Set(GRUPOS_LIQUIDACION.flatMap((g) => g.opciones.flatMap((o) => o.rbacPermissions)))];

@Component({
  selector: 'app-parametros-liquidacion',
  templateUrl: './parametros-liquidacion.component.html',
})
export class ParametrosLiquidacionComponent implements OnInit {
  readonly grupos = GRUPOS_LIQUIDACION;
  userRoles: string[] = [];

  constructor(public _auth: AuthService) { }

  ngOnInit(): void {
    this.userRoles = Array.isArray(this._auth.sessionUser?.profile) ? this._auth.sessionUser.profile : [];
  }

  /** Mismas reglas que el tablero de Parámetros: con RBAC, su permiso; sin RBAC, el perfil. */
  puedeVer(o: OpcionLiquidacion): boolean {
    if (this._auth.hasRbac$.getValue()) return this._auth.hasAnyPermission(o.rbacPermissions);
    return o.requiredRoles.some((r) => this.userRoles.includes(r));
  }

  visibles(g: { opciones: OpcionLiquidacion[] }): OpcionLiquidacion[] { return g.opciones.filter((o) => this.puedeVer(o)); }
}
